'use strict';

angular.module('atex.dam').directive('damColorCodingMultiple', ['$http', 'DamMarkAsService', 'DamActivityService',
function($http, DamMarkAsService, DamActivityService) {
  return {
    restrict: 'ACE',
    templateUrl: 'views/dam-color-coding-multiple.html',
    replace: true,
    scope: {
      showlabel: "=",
      values: "=",
      showCaret: "=",
      buttonStyle: "="
    },
    link: function (scope, element, attrs) {
      if (scope.showCaret === undefined) {
        scope.showCaret = true;
      }

      if (!scope.buttonStyle) {
        scope.buttonStyle = "";
      }

      DamMarkAsService.loadColors().then(function (colors) {
        scope.colors = colors;

        scope.$watch('values', function (values, oldValues) {
          if (values !== oldValues && values.length <= 1) {
            scope.ccolor = "white";
            scope.clabel = "None";
          }
        }, true);

        scope.saving = false;
        scope.ccolor = "white";
        scope.clabel = "None";

        element.find('button').click(function (e) {
          dropDownFixPosition($(".color-coding-button-to-fix"), $(".color-coding-ul-to-fix"));
          if (e) {
            element.toggleClass('open');
            e.stopPropagation();
          }
        });

        scope.$on('$destroy', function () {
          element.find('button').off("click");
        });

        function dropDownFixPosition(button, dropdown) {
          if (button.length > 1) {
            button = angular.element(button[button.length - 1]);
          }

          var dropDownTop = button.offset().top + button.outerHeight();
          dropdown.css('top', dropDownTop + "px");
          dropdown.css('left', button.offset().left + "px");
        }

        scope.update = function (color, label, colorId) {
          scope.saving = true;
          var locked = false;
          var idlist = [];
          $.each(scope.values, function (index, value) {
            idlist.push(value.id);
          });
          DamActivityService.lock(idlist).then(function (responses) {
            locked = true;
            scope.ccolor = color;
            scope.clabel = label;
            var data = {
              'aspects': {
                'contentData': {
                  'data': {
                    '_type': 'com.atex.onecms.app.dam.markas.DamMarkAsBean',
                    'id': JSON.parse(JSON.stringify(idlist)),
                    'field': 'colorcoding',
                    'value': colorId
                  }
                }
              }
            };
            var url = "/onecms/dam/content/metadata/markas";
            return $http.put(url, data);
          }).then(function (response) {
            scope.saving = false;
            $.each(scope.values, function (index, value) {
              var update = {};
              update["id"] = value.id;
              update["color"] = color;
              update["label"] = label;
              update["colorId"] = colorId;
              scope.$root.$broadcast("dam:colorCodingUpdate", update);
            });
            DamActivityService.unlock(idlist);
          }).then(null, function (error) {
            scope.saving = false;
            if (locked) {
              DamActivityService.unlock(idlist);
            }
          });
        };
      });
    }
  };
}]);
